import { TipoMovimentacao } from '@app/models/processo-movimentacao';

export class FiltrosObterMovimentacoesProcessuais {
  TipoMovimentacao: TipoMovimentacao;
  ProcessoId: number;
  QuantidadeRegistros: number = 0;
  Pagina: number = 1;
}
